import React, { Component } from "react";
import NavBar1 from '../../components/Navbar1/NavBar1';
import Footer from "../../components/Footer/Footer";
import BookingTabs from "./BookingTabs/bookingTabs";
// import ScrollToTop from "../../Components/Common/ScrollToTop";

class MyBookings extends Component {
  state = {};
  render() {
    window.scrollTo(0, 0);
    // console.clear();
    return (
      <>
     
        <NavBar1 /> 
       
        <Footer >
          <BookingTabs />
        </Footer>
        {/* <ScrollToTop /> */}
      </>
    );
  }
} 

export default MyBookings;
